import React from 'react';
import { Language } from '@/types';
import { ExchangeCard } from './ExchangeCard';
import { Loading, Alert } from '@/components/common';
import { getTranslation } from '@/constants';
import { useExchanges } from '@/hooks';
import { useAuth } from '@/context/AuthContext';

interface IncomingRequestsProps {
  language: Language;
  onChatOpen: (exchangeId: string) => void;
}

export const IncomingRequests: React.FC<IncomingRequestsProps> = ({ language, onChatOpen }) => {
  const { user } = useAuth();
  const { incomingRequests, acceptRequest, declineRequest, loading, error } = useExchanges(
    user?.uid
  );
  const t = getTranslation(language);

  const handleAccept = async (exchangeId: string) => {
    try {
      await acceptRequest(exchangeId);
    } catch (err) {
      console.error('Error accepting request:', err);
    }
  };

  const handleDecline = async (exchangeId: string) => {
    try {
      await declineRequest(exchangeId);
    } catch (err) {
      console.error('Error declining request:', err);
    }
  };

  if (loading) {
    return <Loading text={t.loading} />;
  }

  return (
    <div className="space-y-4">
      {error && <Alert variant="error">{error}</Alert>}

      {incomingRequests.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500">{t.noExchanges}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {incomingRequests.map((exchange) => (
            <ExchangeCard
              key={exchange.id}
              exchange={exchange}
              language={language}
              currentUserId={user?.uid}
              onAccept={handleAccept}
              onDecline={handleDecline}
              onChat={onChatOpen}
            />
          ))}
        </div>
      )}
    </div>
  );
};
